import { useState, useEffect } from 'react';
import {
  extractKeywordsWithFrequency,
  formatKeywordData,
} from 'helpers/FormatKeywordsHelper';

export const useTextForm = (textData, isLoading) => {
  const [textTitle, setTextTitle] = useState('');
  const [keyword, setKeyword] = useState('');
  const [url, setUrl] = useState('');
  const [titleTag, setTitleTag] = useState('');
  const [metaDescriptionTag, setMetaDescriptionTag] = useState('');
  const [actualTextContent, setActualTextContent] = useState('');
  const [actualHtmlContent, setActualHtmlContent] = useState('');
  const [analyseText, setAnalyseText] = useState('');
  const [analyseResult, setAnalyseResult] = useState(null);
  const [keywords, setKeywords] = useState('');
  const [combinedKeywords, setCombinedKeywords] = useState('');
  const [combinedKeywordsList, setCombinedKeywordsList] = useState([]);
  const [list, setList] = useState({});
  const [stuffedKeywords, setStuffedKeywords] = useState([]);
  const [websites, setWebsites] = useState('');

  useEffect(() => {
    if (!textData) return;

    setTextTitle(textData.textTitle || '');
    setKeyword(textData.keyword || '');
    setUrl(textData.url || '');
    setTitleTag(textData.titleTag || '');
    setMetaDescriptionTag(textData.metaDescriptionTag || '');
    setActualTextContent(textData.actualTextContent || '');
    setActualHtmlContent(textData.actualHtmlContent || '');
    setAnalyseText(
      textData.actualTextContent || textData.actualHtmlContent || ''
    );
    setStuffedKeywords(textData.stuffedKeywords || []);
    setWebsites(textData.internalLinking || '');

    if (textData.analyseResult) {
      try {
        const result = JSON.parse(textData.analyseResult);
        setAnalyseResult(
          typeof result === 'string' ? JSON.parse(result) : result
        );
      } catch (e) {
        console.error('Error parsing analyseResult', e);
      }
    }

    if (textData.semanticGap) {
      setKeywords(extractKeywordsWithFrequency(textData.semanticGap));
      setCombinedKeywords(formatKeywordData(textData.semanticGap));
      setCombinedKeywordsList(textData.semanticGap);
      setList(
        textData.semanticGap.reduce((acc, curr) => {
          const word = (curr.word || curr.name || '').toString().trim();
          if (!word) return acc;
          const frequency = Number(curr.frequency ?? curr.count ?? 1);
          acc[word] = Number.isFinite(frequency) ? frequency : 1;
          return acc;
        }, {})
      );
    }
  }, [textData, isLoading]);

  return {
    // State values
    textTitle,
    keyword,
    url,
    titleTag,
    metaDescriptionTag,
    actualTextContent,
    actualHtmlContent,
    analyseText,
    analyseResult,
    keywords,
    combinedKeywords,
    combinedKeywordsList,
    list,
    stuffedKeywords,
    websites,
    // Setters
    setTextTitle,
    setKeyword,
    setUrl,
    setTitleTag,
    setMetaDescriptionTag,
    setActualTextContent,
    setActualHtmlContent,
    setAnalyseText,
    setAnalyseResult,
    setKeywords,
    setCombinedKeywords,
    setCombinedKeywordsList,
    setList,
    setStuffedKeywords,
    setWebsites,
  };
};
